import posthog from "posthog-js";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { RequestContent } from "./components/RequestContent";
import { useUser } from "./context/user-context";

export default function RequestInfo() {
  // Get ID from URL requestId
  const { requestId } = useParams();
  const workspaceId = useUser()?.activeWorkspaceId;

  const hasTracked = useRef(false);
  useEffect(() => {
    if (!hasTracked.current && requestId) {
      posthog.capture("Request Log Viewed", { workspace_id: workspaceId });
      hasTracked.current = true;
    }
  }, [requestId, workspaceId]);

  return <RequestContent requestId={requestId ?? ""} />;
}
